import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useState, useRef} from "react";
import axiApi from "ApiCaller";
import ModalSelectAssetTable from "./ModalSelectAssetTable";
import {AssetChoiceModel} from "./AssetModels";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";


const ModalSelectAsset = ({show, setShow}) => {
    const [item, setItem] = useState({...AssetChoiceModel});
    const items = useRef({
        all: [],
        showed: []
    });
    const [assetsShow, setAssetsShow] = useState([]);
    const handleClose = () => {
        setShow(false);
    }

    const handleAccept = () => {
        setShow(false);
        publishEvent("changeselectedasset", item);
    }

    useEffect(() => {
        axiApi.get(`/api/assets/selectable-list/`).then((resp) => {
            items.current.all = resp.data.items;
            items.current.showed = resp.data.items;
            setAssetsShow(resp.data.items)
        });
    }, []);



    const onSearch = (e) => {
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
            setAssetsShow(
                items.current.all.filter(
                    _item => toLowCaseCleanSpaces(_item.name).includes(valueSearched)
                )
            )
        } else {
            setAssetsShow([...items.current.all]);
        }
    };


    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true} scrollable={true} size="lg" aria-modal>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="trash-can"/>
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Contenedores</Modal.Title>
                        <form className="d-inline-flex ms-2" role="search">
                            <input className="form-control border-end-0 rounded-0" type="search"
                                   placeholder="Nombre"
                                   aria-label="Search"
                                   onChange={onSearch}
                            />
                            <span className="input-group-text bg-white border-start-0 rounded-0"
                                  id="basic-addon1">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass"/>
                        </span>
                        </form>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <ModalSelectAssetTable
                        items={items}
                        itemsShow={assetsShow}
                        setItemsShown={setAssetsShow}
                        setItem={setItem}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Descartar
                    </Button>
                    <Button variant="primary" onClick={handleAccept}>
                        Seleccionar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );


}

export default ModalSelectAsset